import { Button } from '@rsos/base-components';
import { SHARE_STEP, type StepId } from './helpers';

interface FieldShareStepButtonsProps {
  currentStep: StepId;
  isStepValid: boolean;
  isSubmitting: boolean;
  isShareLimitReached: boolean;
  onCancel: () => void;
  onClose: () => void;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

/**
 * Footer button row for the Field Share modal. Renders different button
 * combinations depending on the current step:
 * - First step (RECIPIENTS) → Cancel + Next
 * - Middle steps (DATA_SOURCES, IAR_SELECT) → Back + Next
 * - Submit step (NOTES) → Back + Share
 * - Share-link display step (SHARE_LINK) → Close
 */
const FieldShareStepButtons = ({
  currentStep,
  isStepValid,
  isSubmitting,
  isShareLimitReached,
  onCancel,
  onClose,
  onBack,
  onNext,
  onSubmit,
}: FieldShareStepButtonsProps) => {
  const isFirstStep = currentStep === SHARE_STEP.RECIPIENTS;
  const isShareLinkDisplay = currentStep === SHARE_STEP.SHARE_LINK;
  const isSubmitStep = currentStep === SHARE_STEP.NOTES;
  const isMiddleStep = !isFirstStep && !isSubmitStep && !isShareLinkDisplay;

  if (isFirstStep) {
    return (
      <>
        <Button btnType="tertiary" type="button" grow onClick={onCancel}>
          Cancel
        </Button>
        <Button
          btnType="primary"
          type="button"
          onClick={onNext}
          disabled={!isStepValid || isShareLimitReached}
          grow
        >
          Next
        </Button>
      </>
    );
  }

  if (isMiddleStep) {
    return (
      <>
        <Button btnType="tertiary" type="button" onClick={onBack} grow>
          Back
        </Button>
        <Button
          btnType="primary"
          type="button"
          onClick={onNext}
          disabled={!isStepValid}
          grow
        >
          Next
        </Button>
      </>
    );
  }

  if (isSubmitStep) {
    return (
      <>
        <Button btnType="tertiary" type="button" onClick={onBack} grow>
          Back
        </Button>
        <Button
          btnType="primary"
          type="submit"
          grow
          disabled={isSubmitting || isShareLimitReached}
          onClick={onSubmit}
        >
          {isSubmitting ? 'Sharing...' : 'Share'}
        </Button>
      </>
    );
  }

  // isShareLinkDisplay
  return (
    <Button btnType="tertiary" type="button" onClick={onClose} grow>
      Close
    </Button>
  );
};

export default FieldShareStepButtons;
